import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { selectToken } from "store/core/selectors";

const ProtectedRoute = ({ children }) => {
    const token = useSelector(selectToken);
    const location = useLocation();
    
    if (!token) {
      // Preserve query string when redirecting to login
      return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
    }
    return children;
};

export default ProtectedRoute;